import { Env, readFromEnv } from '@cinch-nx/environments'
import axios from 'axios'

export const feesClient = axios.create({
  baseURL: readFromEnv(Env.LogisticsFeesServiceUrl),
})
